module.exports = __webpack_public_path__ + "img/stock5.fc8f6c8d.png";